import React from "react";
import { SwarovskiOptikLocaleFrontend } from "@swo/storefront";
import { css } from "@emotion/react";
import { FONTS } from "../../styles/fonts";
import { getReviewScoreFormatter } from "./PDP_SingleImageCarousel/getReviewScoreFormatter";
import { ReviewsLabel } from "./PDP_SingleImageCarousel/ReviewsLabel";
import { PDPReviewStars } from "./PDP_SingleImageCarousel/PDPReviewStars";
import { ReviewTranslations } from "./reviewTranslations";
import { CSS_MQ } from "../../styles/breakpoints";

export const PDPReviewBox: React.FC<{
  locale: SwarovskiOptikLocaleFrontend;
  averageRating: number;
  reviewsCount: number;
  t: ReviewTranslations;
}> = ({ locale, averageRating, reviewsCount, t }) => {
  const formattedAverageRating = getReviewScoreFormatter(locale).format(averageRating);

  return (
    <div
      className="so-bg-green-dark so-color-white u-flex u-flex-col u-gap-2 u-jc-center u-ai-center"
      css={css`
        aspect-ratio: 1;
      `}
    >
      <span
        css={[
          FONTS.SwarovskiFutura700,
          css`
            font-size: 48px;
            ${CSS_MQ.atLeastMd} {
              font-size: 80px;
            }
            line-height: 0.9;
            letter-spacing: -0.05em;
          `,
        ]}
      >
        {formattedAverageRating}
      </span>

      <span className="u-uppercase" css={[FONTS.SwarovskiFutura500]}>
        <ReviewsLabel reviewsCount={reviewsCount} t={t} />
      </span>

      <PDPReviewStars starsTheme="light" rating={averageRating} />
    </div>
  );
};
